const Mock = require('mockjs')
// 调用的tabList标签mock
Mock.mock('http://localhost:4000/menus', 'get', function(options) {
	// console.log(options)
	return {
		menus: [{
				id: 103,
				authName: '预约审核',
				path: 'null',
				children: [{
					id: 145,
					authName: '考核人数统计',
					path: 'Welcome',
					children: []
				}]
			},
			{
				id: 101,
				authName: '考试管理',
				path: null,
				children: [{
						id: 101,
						authName: '个人预约',
						path: 'fraction',
						children: []
					},
					{
						id: 105,
						authName: '团体预约',
						path: 'groupBooking',
						children: []
					}
				]
			},
			{
				id: 105,
				authName: '二维码管理',
				path: null,
				children: [{
					id: 145,
					authName: '隐患点管理',
					path: 'danger',
					children: []
				}]
			},
			{
				id: 150,
				authName: '反恐实训',
				path: null,
				children: [{
						id: 151,
						authName: '重点车辆考题',
						path: 'question/wc',
						children: []
					},
					{
						id: 152,
						authName: '反恐防爆考题',
						path: 'question/fank',
						children: []
					},
					{
						id: 153,
						authName: '反恐防爆知识点',
						path: 'knowledge/fank',
						children: []
					}
				]
			},
			{
				id: 160,
				authName: '客运车实训',
				path: null,
				children: [{
						id: 161,
						authName: '客运车安全考题',
						path: 'question/kyz',
						children: []
					},
					{
						id: 162,
						authName: '客运车安全知识点',
						path: 'knowledge/kycaq',
						children: []
					}
				]
			},
			{
				id: 165,
				authName: '生态治理实训',
				path: null,
				children: [{
						id: 166,
						authName: '生态治理考题',
						path: 'question/stzl',
						children: []
					},
					{
						id: 167,
						authName: '生态治理知识点',
						path: 'knowledge/hdzl',
						children: []
					}
				]
			},
			{
				id: 170,
				authName: '市场监管局实训',
				path: null,
				children: [{
						id: 171,
						authName: '食品加工考题',
						path: 'question/spxzf',
						children: []
					},
					{
						id: 172,
						authName: '食品加工知识点',
						path: 'knowledge/spjgxzf',
						children: []
					},
					{
						id: 173,
						authName: '餐饮店厨房考题',
						path: 'question/cydcf',
						children: []
					},
					{
						id: 174,
						authName: '餐饮店厨房知识点',
						path: 'knowledge/cydcf',
						children: []
					},
					{
						id: 175,
						authName: '便民超市考题',
						path: 'question/bld',
						children: []
					},
					{
						id: 176,
						authName: '便民超市知识点',
						path: 'knowledge/bmcs',
						children: []
					},
					{
						id: 177,
						authName: '特种设备考题',
						path: 'question/tzsb',
						children: []
					},
					{
						id: 178,
						authName: '特种设备知识点',
						path: 'knowledge/dxylss',
						children: []
					}
				]
			},
			{
				id: 180,
				authName: '文广旅游局实训',
				path: null,
				children: [{
						id: 181,
						authName: '网吧考题',
						path: 'question/wb',
						children: []
					},
					{
						id: 182,
						authName: '网吧知识点',
						path: 'knowledge/wb',
						children: []
					},
					{
						id: 183,
						authName: '书店考题',
						path: 'question/sd',
						children: []
					},
					{
						id: 184,
						authName: '书店知识点',
						path: 'knowledge/sd',
						children: []
					}
				]
			},
			{
				id: 190,
				authName: '消防救援大队实训',
				path: null,
				children: [{
						id: 191,
						authName: '童装厂考题',
						path: 'question/tzc',
						children: []
					},
					{
						id: 192,
						authName: '童装厂知识点',
						path: 'knowledge/tzc',
						children: []
					},
					{
						id: 193,
						authName: '出租屋考题',
						path: 'question/czw',
						children: []
					},
					{
						id: 194,
						authName: '出租屋知识点',
						path: 'knowledge/czw',
						children: []
					}
				]
			},
			{
				id: 220,
				authName: '应急管理局实训',
				path: null,
				children: [{
						id: 221,
						authName: '生产车间考题',
						path: 'question/aqsc',
						children: []
					},
					{
						id: 222,
						authName: '生产车间知识点',
						path: 'knowledge/sccj',
						children: []
					},
					{
						id: 223,
						authName: '应急救护考题',
						path: 'question/yjjy',
						children: []
					},
					{
						id: 224,
						authName: '应急救护知识点',
						path: 'knowledge/yjjy',
						children: []
					},
					{
						id: 225,
						authName: '危化企业考题',
						path: 'question/weih',
						children: []
					},
					{
						id: 226,
						authName: '危化企业知识点',
						path: 'knowledge/weih',
						children: []
					}
				]
			},
			{
				id: 230,
				authName: '住建局实训',
				path: null,
				children: [{
						id: 231,
						authName: '施工用电考题',
						path: 'question/dg',
						children: []
					},
					{
						id: 232,
						authName: '施工用电知识点',
						path: 'knowledge/dg',
						children: []
					},
					{
						id: 233,
						authName: '燃气安全考题',
						path: 'question/rq',
						children: []
					},
					{
						id: 234,
						authName: '燃气安全知识点',
						path: 'knowledge/rq',
						children: []
					},
					{
						id: 235,
						authName: '建筑工地考题',
						path: 'question/jzsgaq',
						children: []
					},
					{
						id: 236,
						authName: '建筑工地知识点',
						path: 'knowledge/jzsgaq',
						children: []
					}
				]
			},
			{
				id: 240,
				authName: '教育局实训',
				path: null,
				children: [{
						id: 241,
						authName: '校园警务室考题',
						path: 'question/xyjws',
						children: []
					},
					{
						id: 242,
						authName: '校园警务室知识点',
						path: 'knowledge/xyjws',
						children: []
					},
					{
						id: 243,
						authName: '校车安全考题',
						path: 'question/xc',
						children: []
					},
					{
						id: 244,
						authName: '校车安全知识点',
						path: 'knowledge/xc',
						children: []
					},
					{
						id: 245,
						authName: '教学楼安全考题',
						path: 'question/jxl',
						children: []
					},
					{
						id: 246,
						authName: '教学楼安全知识点',
						path: 'knowledge/jxl',
						children: []
					},
					{
						id: 247,
						authName: '学生宿舍考题',
						path: 'question/xsss',
						children: []
					},
					{
						id: 248,
						authName: '学生宿舍知识点',
						path: 'knowledge/xsss',
						children: []
					}
				]
			},
			{
				id: 250,
				authName: '防线办实训',
				path: null,
				children: [{
						id: 251,
						authName: '国家安全考题',
						path: 'question/gjaq',
						children: []
					},
					{
						id: 252,
						authName: '国家安全知识点',
						path: 'knowledge/guojia',
						children: []
					}
				]
			},
			{
				id: 260,
				authName: '反邪办实训',
				path: null,
				children: [{
						id: 261,
						authName: '防范邪教考题',
						path: 'question/xj',
						children: []
					},
					{
						id: 262,
						authName: '防范邪教知识点',
						path: 'knowledge/xj',
						children: []
					}
				]
			}
		] //
	}
})

// 测试人数据
// Mock.mock('http://localhost:4000/demo', 'get', function (options) {
//   console.log(options)
//   return {
//     demo :[
//       {
//         name: '张三',
//         date: '2016-05-02',
//         id: '856236',
//         province: '上海',
//         phone: '123456789',
//         zip: 88,
//       },
//       {
//         name: '李四',
//         date: '2016-05-02',
//         id: '856236',
//         province: '上海',
//         phone: '123456789',
//         zip: 2033,
//       },
//       {
//         name: '王五',
//         date: '2016-05-02',
//         id: '856236',
//         province: '上海',
//         phone: '123456789',
//         zip: 李六,
//       }],
//         meta: { status: 200, message: '获取数据成功！' }
//   }
// })
